import { inject } from '@angular/core';
import { CanActivateFn, ActivatedRouteSnapshot, Router } from '@angular/router';
import { toObservable } from '@angular/core/rxjs-interop';
import { filter, map, take } from 'rxjs/operators';

import { AppRoleValue } from '../models/api/departments';
import { AppRoleService } from '../services/app-role.service';

export const roleGuard: CanActivateFn = (route: ActivatedRouteSnapshot) => {
  const appRoleService = inject(AppRoleService);
  const router = inject(Router);

  const requiredRole = route.data['requiredRole'] as AppRoleValue | undefined;

  if (!requiredRole) {
    return true;
  }

  // If roles are already loaded, check immediately
  if (appRoleService.roles() != null) {
    return appRoleService.roles()!.includes(requiredRole) || router.createUrlTree(['/access-denied']);
  }

  // Roles not yet loaded — wait for them to become non-null
  return toObservable(appRoleService.roles).pipe(
    filter((roles) => roles != null),
    take(1),
    map((roles) => roles!.includes(requiredRole) || router.createUrlTree(['/access-denied'])),
  );
};
